// src/components/dashboard/CarbonIntensityChart.js
import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import { useCarbonIntensity } from "../../hooks/useCarbonIntensity";

export default function CarbonIntensityChart({
  scenario,
  from = 2025,
  to = 2050,
  className = "w-full h-96",
  title = "Electricity System Carbon Intensity",
}) {
  const {
    loading,
    error,
    labels,
    intensity,
    baselineIntensity,
    finalIntensity,
    intensityReductionPercentage,
  } = useCarbonIntensity({ scenario, from, to ,debug: true});

  const data = useMemo(
    () => ({
      labels,
      datasets: [
        {
          label: "Carbon intensity (gCO₂/kWh)",
          data: intensity,
          borderColor: "#2563eb",
          backgroundColor: "rgba(37,99,235,0.15)",
          tension: 0.3,
          fill: false,
          pointRadius: 0,
        },
      ],
    }),
    [labels, intensity]
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { position: "top" },
      title: { display: false, text: title },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            `${ctx.dataset.label}: ${Number(ctx.parsed.y ?? 0).toLocaleString(undefined, {
              maximumFractionDigits: 1,
            })} gCO₂e/kWh`,
        },
      },
    },
    scales: {
      x: { title: { display: true, text: "Year" } },
      y: {
        min: -50,
        max: 100,
        title: { display: true, text: "gCO₂e/kWh" },
        beginAtZero: false,
      },
    },
  };

  if (loading) return <div className={className + " grid place-items-center"}>Loading carbon intensity…</div>;
  if (error) return <div className={className + " grid place-items-center text-red-600"}>Error: {error.message}</div>;
  if (!labels?.length) return <div className={className + " grid place-items-center text-gray-500"}>No data.</div>;

  const pretty = (n) =>
    Number(n ?? 0).toLocaleString(undefined, { maximumFractionDigits: 1 });

  return (
    <>
      <div className={className}>
        <Line data={data} options={options} />
      </div>

      <div className=" text-gray-500 mt-2 text-center">
        Carbon intensity reduction of{" "}
        {pretty(intensityReductionPercentage)}%
        {/* {pretty(baselineIntensity)} to {pretty(finalIntensity)} gCOe₂/kWh */}
      </div>
    </>
  );
}

